/**
 * Entity code filter for cashier views.
 * Only wallets from this entity will be displayed in cashier activity.
 */
export const CASHIER_ENTITY_CODE = 'FNK';

/**
 * Check if the current entity is allowed for cashier wallet operations.
 * Returns true only if the entity code matches CASHIER_ENTITY_CODE.
 */
export function isCashierEntityAllowed(entityCode: string | undefined): boolean {
  return entityCode?.toUpperCase() === CASHIER_ENTITY_CODE;
}
